import React from 'react';

/**
 * A reusable card component with consistent styling
 * @param {Object} props - Component props
 * @param {string} props.title - Card title
 * @param {React.ReactNode} props.children - Card content
 * @param {React.ReactNode} props.footer - Card footer content
 * @param {boolean} props.hover - Whether the card should have hover effects
 * @param {string} props.className - Additional CSS classes
 */
const Card = ({ 
  title, 
  children, 
  footer, 
  hover = true, 
  className = '' 
}) => {
  return (
    <div className={`card ${hover ? 'hover-lift' : ''} ${className}`}>
      {title && (
        <div className="card-header">
          <h3 className="mb-0">{title}</h3>
        </div>
      )}
      
      <div className="card-body">
        {children}
      </div>
      
      {footer && (
        <div className="card-footer">
          {footer}
        </div>
      )}
    </div>
  );
};

export default Card;
